import { SET_GLOBAL_USERS_LIST } from '../constants';

export const setGlobalUsers = (users) => {
  return {
    type: SET_GLOBAL_USERS_LIST,
    payload: users,
  };
};
